import _ from 'lodash';
import https from 'https'
import 'cross-fetch/polyfill';

const API_ENDPOINT = "ay4op9wl42.execute-api.ap-southeast-2.amazonaws.com/Prod/"
const API_PROTOCOL = "https://"
const API_REGION = "ap-southeast-2"

function pathClientUrl(pathOrStub) {
    const raw = String(pathOrStub || "").replace(/^\/+/, "")
    return raw.split("/")[0]
}

function accessCodeStorageKey(clientId) {
    return "s50-event-access-code:" + pathClientUrl(clientId)
}

export function storeEventAccessCode(clientId, code) {
    try {
        window.sessionStorage.setItem(accessCodeStorageKey(clientId), String(code || "").trim())
    } catch (error) {}
}

function storedEventAccessCode(clientId) {
    try {
        return window.sessionStorage.getItem(accessCodeStorageKey(clientId)) || ""
    } catch (error) {
        return ""
    }
}

function mapV2EventPayload(data) {
    if (!data || !data.found || !data.hasEvent) return null
    const brand = data.brand || {}
    const org = data.organisation || {}
    const event = data.event || {}
    const locked = Boolean(data.locked)
    return {
        hasEvents: true,
        client: {
            v2: true,
            PK: data.clientUrl,
            stub: data.clientUrl,
            name: org.orgName || org.name || org.organisationName || data.clientUrl,
            styles: {
                logo: brand.logoUrl,
                logoScale: brand.logoScale,
                backgroundUrl: brand.backgroundUrl,
                hero: brand.backgroundUrl,
                logoFrame: brand.logoMask,
                logoMask: brand.logoMask,
                logoBg: brand.logoBackgroundColor,
                logoBackgroundColor: brand.logoBackgroundColor,
                overlayColor: brand.overlayColor,
                overlayOpacity: brand.overlayOpacity,
                primaryColor: brand.primaryColor,
                secondaryColor: brand.secondaryColor,
                prizePoolMessageOverrideEnabled: Boolean(brand.prizePoolMessageOverrideEnabled),
                prizePoolMessageOverride: brand.prizePoolMessageOverride || ""
            }
        },
        event: {
            ...event,
            v2: true,
            locked: locked,
            eventId: event.eventId,
            title: locked ? "Private event" : event.name,
            completed: event.status === "complete",
            pending: event.status === "pending",
            drawPending: false,
            bundles: (event.ticketBundles || []).reduce((acc, bundle) => {
                acc[bundle.price] = bundle.tickets
                return acc
            }, {})
        }
    }
}

function mapV2PastEvents(data) {
    return ((data && data.events) || []).map((event) => ({
        ...event,
        v2: event.source !== "legacy",
        legacy: event.source === "legacy" || Boolean(event.legacy),
        source: event.source || "v2",
        completed: event.status === "complete",
        SK: event.eventId,
        endDate: event.completedAt || event.drawDate
    }))
}

function parseResponse(res) {

    var promise = new Promise((resolve, reject) => {

        var parsedData = null
        var errorMsg = ""

        res.setEncoding('utf8');
        let rawData = '';
        res.on('data', (chunk) => { rawData += chunk; });
        res.on('end', () => {
            try {
                parsedData = JSON.parse(rawData);

            } catch (e) {
                errorMsg = e.message
            }
            if (parsedData) {
                resolve(parsedData)
            } else {
                resolve({
                    error: errorMsg
                })
            }
        });
    });

    return promise

}


function onTest(data) {

    return {
        type: 'TEST',
        data: data,
        receivedAt: Date.now()
    }
}

export function test(data) {
    return function (dispatch) {
        let val = data;
        dispatch(onTest(val))
    }
}

export function testAsync() {
    return function (dispatch) {
        return new Promise((resolve, reject) => {
            setTimeout(function () {
                let val = Math.random();
                dispatch(onTest(val))
                resolve();
            }, 1500)


        })
    }
}

function onFetchEvent(data) {

    return {
        type: 'FETCH_EVENT',
        data: data,
        receivedAt: Date.now()
    }
}

export function fetchEvent(clientId) {
    clientId = pathClientUrl(clientId);

    return function (dispatch) {
        return new Promise(async (resolve, reject) => {
            try {
                const params = new URLSearchParams({ clientUrl: clientId })
                const accessCode = storedEventAccessCode(clientId)
                if (accessCode) params.set("accessCode", accessCode)
                const v2Res = await fetch(API_PROTOCOL + API_ENDPOINT + "v2/public/event?" + params.toString())
                if (v2Res && v2Res.ok) {
                    const v2Data = await v2Res.json()
                    const mapped = mapV2EventPayload(v2Data)
                    if (mapped) {
                        dispatch(onFetchEvent(mapped))
                        resolve(mapped.event.locked ? "locked" : true)
                        return
                    }
                    if (v2Data && v2Data.found) {
                        dispatch(onFetchEvent(null))
                        resolve(false)
                        return
                    }
                }
            } catch (error) {}

            // get client by stub
            const res = await fetch(API_PROTOCOL + API_ENDPOINT + "getlatestevent?stub=" + clientId)
            if (!res || !res.ok) {
                dispatch(onFetchEvent(null))
                resolve(false);
            } else {
                const data = await res.json()
                if (data && data.hasEvents) {
                    dispatch(onFetchEvent(data))
                    resolve(data.hasEvents);
                } else {
                    dispatch(onFetchEvent(null))
                    resolve(false);
                }
            }


        })
    }
}

function onFetchPastEvents(data) {

    return {
        type: 'FETCH_PAST_EVENT',
        data: data,
        receivedAt: Date.now()
    }
}

export function fetchPastEvents(clientId) {
    return function (dispatch) {
        return new Promise(async (resolve, reject) => {
            if (clientId && String(clientId).indexOf("CLIENT#") !== 0) {
                try {
                    const v2Res = await fetch(API_PROTOCOL + API_ENDPOINT + "v2/public/events?clientUrl=" + encodeURIComponent(pathClientUrl(clientId)))
                    if (v2Res && v2Res.ok) {
                        const v2Data = await v2Res.json()
                        const events = mapV2PastEvents(v2Data)
                        dispatch(onFetchPastEvents(events))
                        resolve(events)
                        return
                    }
                } catch (error) {}
            }

            // get client by stub
            const res = await fetch(API_PROTOCOL + API_ENDPOINT + "getclientevents?clientId=" + clientId)
            if (!res || !res.ok) {
                dispatch(onFetchPastEvents(null))
                resolve([]);
            } else {
                const data = await res.json()
                if (data) {
                    dispatch(onFetchPastEvents(data))
                    resolve(data);
                } else {
                    dispatch(onFetchPastEvents(null))
                    resolve([]);
                }
            }


        })
    }
}

export function purchase(data) {
    return function (dispatch) {
        return new Promise(async (resolve, reject) => {
            if (data.v2) {
                try {
                    const accessCode = data.accessCode || storedEventAccessCode(data.clientUrl || data.clientId)
                    const res = await fetch(API_PROTOCOL + API_ENDPOINT + "v2/public/tickets/purchase", {
                        method: "POST",
                        headers: { 'Content-Type': 'application/json; charset=UTF-8' },
                        body: JSON.stringify({ ...data, accessCode: accessCode })
                    })
                    const body = await res.json().catch(() => null)
                    if (!res || !res.ok) {
                        resolve({ success: false, message: (body && body.message) || "There was an error processing your purchase. Please try again." })
                        return
                    }
                    resolve(body)
                    return
                } catch (error) {
                    resolve({ success: false, message: "There was an error processing your purchase. Please try again." })
                    return
                }
            }
            // get client by stub
            const res = await fetch(API_PROTOCOL + API_ENDPOINT + "buytickets", {
                method:"POST",
                headers: { 'Content-Type' : 'application/json; charset=UTF-8' },
                body:JSON.stringify({
                    clientId: data.clientId,
                    eventId: data.eventId,
                    ticketCount: data.ticketCount,
                    phone: data.phone,
                    cardName: data.cardName,
                    cardNumber: data.cardNumber,
                    expiryMonth: data.expiryMonth,
                    expiryYear: data.expiryYear,
                    cvc: data.cvc,
                    email: data.email,
                    optIn: data.optIn,
                    addressRequired: Boolean(data.addressRequired),
                    addressNumber: data.addressNumber,
                    addressStreet: data.addressStreet,
                    addressSuburb: data.addressSuburb,
                    addressPostcode: data.addressPostcode,
                    addressState: data.addressState
                })
            })
            if (!res || !res.ok) {
                resolve({ok:false, message:"There was an error processing your purchase. Please try again."});
            } else {
                const data = await res.json()
                if (data) {
                    resolve(data);
                } else {
                    resolve({ok:false, message:"There was an error processing your purchase. Please try again."});
                }
            }


        })
    }
}

function onGetEventPurchases(data) {

    return {
        type: 'GET_EVENT_PURCHASES',
        data: data,
        receivedAt: Date.now()
    }
}

export function getEventPurchases(eventId, phone, options = {}) {
    return function (dispatch) {
        return new Promise(async (resolve, reject) => {
            try {
                const params = new URLSearchParams({
                    eventId: eventId,
                    phone: phone
                })
                if (options.source) params.set("source", options.source)
                if (options.clientUrl) params.set("clientUrl", pathClientUrl(options.clientUrl))
                const v2Res = await fetch(API_PROTOCOL + API_ENDPOINT + "v2/public/tickets/check?" + params.toString())
                if (v2Res && v2Res.ok) {
                    const v2Data = await v2Res.json()
                    const purchases = (v2Data && v2Data.purchases) || []
                    dispatch(onGetEventPurchases(purchases))
                    resolve(purchases)
                    return
                }
            } catch (error) {}

            // get client by stub
            const res = await fetch(API_PROTOCOL + API_ENDPOINT + "geteventpurchases?eventId=" + eventId + "&phone=" + phone)
            if (!res || !res.ok) {
                dispatch(onGetEventPurchases(null))
                resolve([]);
            } else {
                const data = await res.json()
                if (data) {
                    dispatch(onGetEventPurchases(data))
                    resolve(data);
                } else {
                    dispatch(onGetEventPurchases(null))
                    resolve([]);
                }
            }


        })
    }
}
